/**
 * @useage
 * <display-step steps="mySteps"></display-step>
 * @attribute show-all-colors : boolean
 * If true, all colors are shown. 
 * Else will show only the active color if false. The active steps is determined by isCurrentStep boolean in the steps array.
 * 
 * @attribute steps : array
 * Each object should contain "name", "color" and "isCurrentStep" for the display to show up correctly 
 * 
 */
'use strict';
import angular from 'angular';

import displayStepTemplateHtmlUrl from '../views/displayStepTemplate.html';

angular.module('steps.directives', [])

    .directive('displayStep', function() {
        return {
            restrict: 'E',
            scope: {
                type: '=',
                typeId: '=',
                steps: '@steps',
                stepObject: '=',
                showAllColors: '='
            },
            templateUrl: displayStepTemplateHtmlUrl,
            link: function($scope, element, attrs) {

                $scope.vm = {};
                $scope.vm.steps = [];

                attrs.$observe('steps', function(newValue) {
                    if (newValue != "") {
                        newValue = angular.fromJson(newValue);
                        if (newValue.length > 0) {
                            $scope.vm.steps = newValue;
                            updateStepsUI();
                        };
                    }
                });

                var updateStepsUI = function() {

                    for (var i = 0; i < $scope.vm.steps.length; i++) {
                        _.each($scope.vm.steps, function(stepObj){
                            stepObj.sequence = parseInt(stepObj.sequence);
                        });
                        $scope.vm.steps = _.orderBy($scope.vm.steps, 'sequence');
                        if ($scope.showAllColors) {
                            $scope.vm.steps[i].displayColor = $scope.vm.steps[i].color;
                        } else {
                            if (!$scope.vm.steps[i].isCurrentStep && !$scope.vm.steps[i].completedStep) {
                                $scope.vm.steps[i].displayColor = '#c3c3c3';
                            } else {

                                //Checking for color. If not available, revert to default color.
                                if ($scope.vm.steps[i].color && $scope.vm.steps[i].color != "") {
                                    $scope.vm.steps[i].displayColor = $scope.vm.steps[i].color;
                                } else {
                                    $scope.vm.steps[i].displayColor = $scope.vm.steps[i].default_color;
                                };

                            }
                        }
                    };
                };

                if ($scope.stepObject) {
                    if ($scope.stepObject.color) {
                        //TODO: Remove this after Owen makes changes to the variable
                        $scope.stepObject.displayColor = $scope.stepObject.color;
                    } else {
                        $scope.stepObject.displayColor = $scope.stepObject.default_color;
                    };
                    $scope.vm.steps.push($scope.stepObject);

                } else if ($scope.steps && $scope.steps.length > 0) {
                    updateStepsUI();

                } else {
                    $scope.vm = {};
                    $scope.vm.steps = [];
                    var stepCount = 1;
                    var colors = ['grey', 'mediumpurple', 'blue', 'red', 'mediumslateblue', 'yellow', 'green', 'black', 'cyan', 'pink', 'purple'];
                    var seq = 0;
                    for (var i = 0; i < stepCount; i++) {
                        seq = Math.floor(Math.random() * 100);
                        $scope.vm.steps.push({ id: 1, sequence: seq, name: '- NA -', heading: 'Step ' + (i + 1).toString(), isVisible: true, displayColor: colors[i] });
                    };
                }
            }
        }
    });